<template>
<v-row>
    <v-col cols="6" sm="6" md="6">
        <label class="label-modal">Password</label>
        <v-text-field :color="$primary" type="password" v-model="MyObject.password" append-icon="cached" @click:append="gerarPassword()"></v-text-field>
    </v-col>
    <v-col cols="6" sm="6" md="6">
        <label class="label-modal">Confirmar password</label>
        <v-text-field :color="$primary" :type="show ? 'text' : 'password'" v-model="cpwd" :rules="pwdRules" @click:append="show = !show" :append-icon="!show ? 'visibility' : 'visibility_off'"></v-text-field>
    </v-col>
</v-row>
</template>

<script>
import CRUD from '@/mixins/_CRUD'
export default {
    mixins: [CRUD],
    props: {
        MyObject: Object,
        RULES: Array
    },
    data: () => ({
        pwdRules: null,
        cpwd: '',
        show: false
    }),
    mounted() {

    },
    created() {
        this.pwdRules = [v => v == this.MyObject.password || '* As passwords não coincidem.'];
    },
    computed: {},
    methods: {
        gerarPassword() {
            this.MyObject.password = this.generatePassword();
            this.cpwd = this.MyObject.password;
        },
        generatePassword() {
            var length = 8,
                charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
                retVal = "";
            for (var i = 0, n = charset.length; i < length; ++i) {
                retVal += charset.charAt(Math.floor(Math.random() * n));
            }
            return retVal;
        }
    },
}
</script>
